import { useState, useRef, useEffect } from 'react'

import { TextInput } from '@mantine/core'

import { useMutation } from '@redwoodjs/web'

import { toast } from 'src/components/Overlays/Toast/Toast'
import { UPDATE_PACKAGE } from 'src/graphql/packages.graphql'

const DEBOUNCE_DELAY = 500

interface ProviderCellProps {
  pkg: {
    packageId: string
    providerPackageId: string
  }
}

const ProviderCell = ({ pkg }: ProviderCellProps) => {
  const [localValue, setLocalValue] = useState(pkg.providerPackageId)
  const debounceRef = useRef<NodeJS.Timeout | null>(null)

  const [updatePackage] = useMutation(UPDATE_PACKAGE, {
    onCompleted: ({ updatePackage: result }) =>
      toast(`${result.name} updated`, 'success'),
    onError: (e) => toast(e?.message || 'Unable to update package', 'error'),
  })

  useEffect(() => {
    setLocalValue(pkg.providerPackageId)
  }, [pkg.providerPackageId])

  const handleChange = (value: string) => {
    setLocalValue(value)
    if (debounceRef.current) clearTimeout(debounceRef.current)
    debounceRef.current = setTimeout(() => {
      updatePackage({
        variables: {
          packageId: pkg.packageId,
          input: { providerPackageId: value },
        },
      })
    }, DEBOUNCE_DELAY)
  }

  return (
    <TextInput
      variant="unstyled"
      size="xs"
      value={localValue}
      onChange={(e) => handleChange(e.target.value)}
    />
  )
}

export default ProviderCell
